import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  EntityState,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { DynamicEntity } from '@app/types';
import { ThunkExtra } from '@app/store';
import {
  DashboardService,
  GetWidgetNewsRequest,
  GetWidgetNewsResponse,
} from '@app/gen/dashboard';

import { DashboardState } from '../../dashboard.state';

export const getNewsList = createAsyncThunk<
  GetWidgetNewsResponse['news'],
  GetWidgetNewsRequest,
  ThunkExtra
>(
  'dashboard/getNewsList',
  async (getNewsListDto, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getWidgetNews({
        body: getNewsListDto,
      });

      return result.news;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const newsListReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getNewsList.pending, (state) => {
    state.newsList.status = 'loading';
  });
  builder.addCase(getNewsList.fulfilled, (state, { payload }) => {
    state.newsList.status = 'complete';
    state.newsList.items = payload;
  });
  builder.addCase(getNewsList.rejected, (state) => {
    state.newsList.status = 'failed';
  });
};
